import { combineReducers } from 'redux';
import duplicatePinPlateReducer from './reducers/duplicate-pin-plate';

export const duplicatePinPlateCombineReducer = () => combineReducers({
    duplicatePinPlateRequest: duplicatePinPlateReducer,

});
